export enum DeliveryTypeDetail {
  Longtime = 'longtime',
  Normal = 'onetime',
  Fast = 'fast',
  Emergency = 'emergency',
}
